import { QueryClient } from '@tanstack/react-query';

function makeQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000, // 1 minute
        // Clinicians alt-tab constantly, and react-query refetches on focus by
        // default — so every return after the stale window re-fired listPatients,
        // listVisits, listReferrals and getPatientCensusStats, each an audited read
        // that writes to Postgres. Freshness after a mutation comes from the
        // invalidations the mutations already perform, not from focus
        // (performance audit FE-6).
        refetchOnWindowFocus: false,
        // The default of three retries issued a failing expensive query four times
        // before the error surfaced, multiplying the cost of exactly the queries
        // most likely to be timing out.
        retry: 1,
        // Unreferenced list data is held for five minutes rather than the default
        // five minutes of inactivity being left implicit; stated so the cache's
        // bound is declared rather than inherited.
        gcTime: 5 * 60 * 1000,
      },
    },
  });
}

let browserQueryClient: QueryClient | undefined = undefined;

export function getQueryClient(): QueryClient {
  if (typeof window === 'undefined') {
    return makeQueryClient();
  }

  // Reuse a single client in the browser so React suspense does not recreate it.
  browserQueryClient ??= makeQueryClient();

  return browserQueryClient;
}
